var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglepaySquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "#DEDEDE",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1226_63158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9185 7.10892C17.7033 6.86303 15.7438 6.53047 15.1964 7.67443C13.5234 10.5723 12.5628 13.6051 11.8398 14.9064C11.9158 14.9503 15.2481 16.8837 15.4839 16.9981C16.233 17.3616 17.4838 17.198 18.0166 16.237C19.4947 13.5712 19.119 14.2652 20.6895 11.5451C21.7044 9.7872 20.4355 7.41583 18.9185 7.10892Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40458 18.8735C7.58858 17.94 6.98999 16.0723 7.70701 15.0264C9.80163 11.3983 11.4784 9.20198 12.7971 7.00049C13.4964 7.40424 16.2982 8.99352 16.4848 9.15727C17.1108 9.7064 17.6294 10.7557 17.0636 11.6976C15.4939 14.3106 14.8498 15.4932 13.2544 18.2566C12.2393 20.0149 9.42398 20.0397 8.40458 18.8735Z",
    fill: "#FDBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9176 5.25962C14.2852 4.30575 13.4462 4.43076 12.5683 4.57155C11.7702 4.77105 10.6911 5.35103 10.2362 6.09614C9.08866 7.97571 8.00173 9.83562 6.59366 12.356C6.15998 13.1323 6.48189 14.086 6.88212 14.4645C7.15335 14.7211 9.14906 15.8222 9.51729 15.9805C10.0382 16.2044 10.8184 16.0487 11.2891 15.5642C11.4191 15.4304 14.3963 10.3166 15.2347 8.80832C15.5886 8.17185 15.9074 7.81962 16.4366 7.4801C17.459 6.9436 18.2573 6.87439 19.4799 7.32147C19.4799 7.32147 16.8189 5.77905 15.9176 5.25962Z",
    fill: "#2DA94F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41356 17.2611C3.77122 16.3244 3.45995 15.5353 3.14294 14.7046C2.91672 13.9138 2.87943 12.6892 3.29727 11.9226C4.35136 9.9891 4.34378 9.9793 5.82251 7.49961C6.27794 6.7359 7.26488 6.53785 7.79281 6.69517C8.15062 6.80174 10.102 7.97953 10.4232 8.2193C10.8777 8.55844 11.1328 9.31205 10.9486 9.96192C10.8977 10.1414 9.03231 13.4152 8.14542 14.8955C7.77106 15.5202 7.62546 15.9723 7.59606 16.6004C7.64261 17.7541 7.98174 18.48 8.98033 19.3153C8.98033 19.3153 6.31399 17.7819 5.41356 17.2611Z",
    fill: "#297AEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1226_63158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 15.9752,
    fill: "white",
    transform: "translate(2.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepaySquare);
export default __webpack_public_path__ + "static/media/googlepay-square.49b290afd586deafcef7d3c0252c5c41.svg";
export { ForwardRef as ReactComponent };